var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsommation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 24,
    viewBox: "0 0 44 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9882 15.703C40.6922 17.5572 41.1559 19.5086 41.3676 21.5H22L2.6324 21.5C2.84406 19.5086 3.30783 17.5572 4.01184 15.703C5.00845 13.0783 6.46424 10.7067 8.28654 8.71875C10.1084 6.73123 12.2594 5.16744 14.6104 4.1051C16.9607 3.04309 19.4709 2.5 22 2.5C24.529 2.5 27.0393 3.04309 29.3896 4.1051C31.7406 5.16744 33.8916 6.73123 35.7135 8.71875C37.5358 10.7067 38.9916 13.0783 39.9882 15.703Z",
    fill: "#D0CCC9",
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 20C20.4 20.8837 21.1163 21.6 22 21.6C22.8837 21.6 23.6 20.8837 23.6 20C23.6 19.1163 22.8837 18.4 22 18.4C21.1163 18.4 20.4 19.1163 20.4 20ZM34 5L30.7734 6.2606L33.4784 8.42461L34 5ZM22.2343 20.1874L32.5476 7.29575L32.0791 6.92094L21.7657 19.8126L22.2343 20.1874Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsommation);
export default __webpack_public_path__ + "static/media/consommation.89a972b726b609954cd2e539ba0524dc.svg";
export { ForwardRef as ReactComponent };